import { render, staticRenderFns } from "./SendProof.vue?vue&type=template&id=50403128&"
import script from "./SendProof.vue?vue&type=script&lang=js&"
export * from "./SendProof.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports